import styles from './ModelQRCodePage_7.module.css'
import { QRCode } from 'antd'

import config from '../../../../config'

import {
  SvgLogoMetro,
  SvgLogoVille,
  SvgStarFull,
} from '../../../svg/SvgComponents'

function ModelQRCodePage_7({
  qrCodeUrl,
  primaryMessage,
  secondaryMessage,
  logo,
}) {
  let iconProps = {}
  let iconSizeGlobal = 100

  if (logo === '1') {
    iconProps = {
      icon: config.URL_IMG_METRO_WHITE,
      iconSize: iconSizeGlobal,
    }
  } else if (logo === '2') {
    iconProps = {
      icon: config.URL_IMG_VILLE_WHITE,
      iconSize: iconSizeGlobal,
    }
  } else if (logo === '3') {
    iconProps = {
      icon: config.URL_IMG_METRO_WHITE,
      iconSize: iconSizeGlobal,
    }
  }
  return (
    <div
      className={styles.page}
      style={{
        width: config.PAGE_QRCODE_WIDTH,
        height: config.PAGE_QRCODE_HEIGHT,
      }}
    >
      <div className={styles.header}>
        {logo === '1' && (
          <div className={styles.content_logo}>
            <SvgLogoMetro />
          </div>
        )}
        {logo === '2' && (
          <div className={styles.content_logo}>
            <SvgLogoVille />{' '}
          </div>
        )}
        {logo === '3' && (
          <>
            <div className={styles.multilogo}>
              <div className={styles.content_logo}>
                <SvgLogoMetro />
              </div>
              <div className={styles.content_ville}>
                <SvgLogoVille />
              </div>
            </div>
          </>
        )}
      </div>

      <div className={styles.qrContainer}>
        <QRCode
          color={'#f9f5f6'}
          bordered={false}
          value={qrCodeUrl}
          size={500}
          {...iconProps}
          style={{}}
        />
      </div>

      <div className={styles.starsContainer}>
        <div className={`${styles.starIcon} ${styles.starLarge}`}>
          <SvgStarFull />
        </div>
      </div>

      <div className={styles.chainContainer}>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
        <div className={styles.line}></div>
        <div className={styles.circle}></div>
      </div>

      <div className={styles.waveContainer}>
        <div className={styles.wave}></div>
        <div className={styles.wave}></div>
        <div className={styles.wave}></div>
        <div className={styles.wave}></div>
      </div>

      <div className={styles.primaryMessage}>{primaryMessage}</div>
      <div className={styles.secondaryMessage}>{secondaryMessage}</div>
    </div>
  )
}

export default ModelQRCodePage_7
